@if (periods.length > 1) {
    <app-tab-list class="mb-5">
        @for (item of periods; track item) {
            <app-tab
                [tabTitle]="
                    ((measurementCycle === 'month'
                        ? 'translate_month'
                        : measurementCycle === 'quarter'
                          ? 'translate_quarter'
                          : 'translate_year_half'
                    ) | translate) +
                    ' ' +
                    (item.period + 1)
                "
            >
                <ng-container
                    [ngTemplateOutlet]="contentTemplate"
                    [ngTemplateOutletContext]="{ period: item }"
                ></ng-container>
            </app-tab>
        }
    </app-tab-list>
} @else {
    <ng-container
        [ngTemplateOutlet]="contentTemplate"
        [ngTemplateOutletContext]="{ period: periods[0] }"
    ></ng-container>
}
